import {
    Component,
    ViewChild,
    Input,
    Output,
    ElementRef,
    EventEmitter
} from '@angular/core';
declare let require: any;
const Chartist = require('../../../pages/plugins/chartist');
const tooltip = require('../../../pages/plugins/chartist-plugin-tooltip');
const Highcharts = require('../../../../../node_modules/highcharts/highcharts');
require('../../../../../node_modules/highcharts/highcharts-more')(Highcharts);
require('../../../../../node_modules/highcharts/modules/solid-gauge')(Highcharts);

@Component({
  selector: 'ba-chartist-chart',
  templateUrl: './baChartistChart.html',
  providers: [],
})
export class BaChartistChart {

  @Input() baChartistChartType:string;
  @Input() baChartistChartData:Object;
  @Input() baChartistChartOptions:Object;
  @Input() baChartistChartResponsive:Object;
  @Input() baChartistChartClass:string;
  @Input() tootltipOptions = {};
  @Output() onChartReady = new EventEmitter<any>();
  @Input() baChartistChartgaugeCounts:number;
  @ViewChild('baChartistChart') public _selector: ElementRef;

  private chart;
  gaugeCountArr = [];
  gaugeCount = 0;
  ngAfterViewInit() {
    if(this.baChartistChartType !== "Traffic Chart"){
      this.baChartistChartOptions['plugins'] = [tooltip(this.tootltipOptions)];
      this.chart = new Chartist[this.baChartistChartType](this._selector.nativeElement, this.baChartistChartData, this.baChartistChartOptions, this.baChartistChartResponsive);
      this.onChartReady.emit(this.chart);
    }else {
      if(this.baChartistChartgaugeCounts !== undefined){
        this.gaugeCountArr.push("container"+this.baChartistChartgaugeCounts);
        let ref = this;
        setTimeout(function() {
            ref.gaugeOptions(ref.baChartistChartData, ref.baChartistChartgaugeCounts, ref.baChartistChartOptions);        
        }, 2000);
      }      
    }
  }
  

  ngOnChanges(changes) {
    if (this.chart) {
      (<any>this.chart).update(this.baChartistChartData, this.baChartistChartOptions);
    }
  }

  ngOnDestroy():void {
    if (this.chart) {
      this.chart.detach();
    }
  }
  gaugeOptions(current, gaugeCount, gaugeOptions) {
    let minCur = gaugeOptions.Min || 0;
    let maxCur = gaugeOptions.Max || 0;
    if (document.getElementById('container'+gaugeCount+'')) {
        Highcharts.chart('container'+gaugeCount+'', {
            chart: {
                type: 'gauge',
                plotBackgroundColor: null,
                plotBackgroundImage: null,
                plotBorderWidth: 0,
                plotShadow: false
            },
            title: {
                text: ''
            },
            pane: {
                startAngle: -150,
                endAngle: 150,
                background: [{
                    backgroundColor: {
                        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                        stops: [
                            [0, '#FFF'],
                            [1, '#333']
                        ]
                    },
                    borderWidth: 0,
                    outerRadius: '109%'
                }, {
                    backgroundColor: {
                        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                        stops: [
                            [0, '#333'],
                            [1, '#FFF']
                        ]
                    },
                    borderWidth: 1,
                    outerRadius: '107%'
                }, {
                    // default background
                }, {
                    backgroundColor: '#DDD',
                    borderWidth: 0,
                    outerRadius: '105%',
                    innerRadius: '103%'
                }]
            },
            // the value axis
            yAxis: {
                min: minCur,
                max: maxCur,
        
                minorTickInterval: 'auto',
                minorTickWidth: 1,
                minorTickLength: 10,
                minorTickPosition: 'inside',
                minorTickColor: '#666',
        
                tickPixelInterval: 30,
                tickWidth: 2,
                tickPosition: 'inside',
                tickLength: 10,
                tickColor: '#666',
                labels: {
                    step: 2,
                    rotation: 'auto'
                },
                title: {
                    text: gaugeOptions.unit
                },
                plotBands: [{
                    from: 0,
                    to: 10000000,
                    color: '#55BF3B' // green
                }]
            },
            series: [{
                name: 'Current',
                data: [current],
                tooltip: {
                    valueSuffix: gaugeOptions.unit
                }
            }]
        }, function (chart) {
            if (!chart.renderer.forExport) {
                var point = chart.series[0].points[0];
                if(point)point.update(maxCur);
                
                }
            });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/baChartistChart/baChartistChart.component.ts